export interface IOfferGeo {
  /** географические координаты объекта размещения */
  coordinates: ICoordinates;
  /** станции метро */
  undergrounds: TOfferUndergrounds | null;
  /** шоссе */
  highways: TOfferHighways | null;
  /** жилой комплекс */
  jk?: IJK;
  /** цепочка адреса по геосущностям */
  address: Array<IGeoAddressItem>;
  /** Адрес в поле ввода */
  userInput: string;
}

export interface ICoordinates {
  /** широта */
  lat: number;
  /** долгота */
  lng: number;
}

export interface IJK {
  /** id жилого комплекса */
  id: number;
  /** название ЖК */
  name: string | null;
  /** дом жилого комплекса */
  house: IJKHouse;
  /** данные о застройщике ЖК */
  developer: IJKDeveloper | null;
}

export interface IJKHouse {
  /** id дома жилого комплекса */
  id: number;
}

export interface IJKDeveloper {
  /** id застройщика */
  id: number | null;
  /** название застройщика */
  name: string | null;
}

export type TOfferUndergrounds = Array<IOfferUnderground>;

export interface IOfferUnderground {
  /** id станции метро */
  id: number;
  /** название станции метро */
  name: string;
  /** цвет линии метро */
  color: string | null;
  /** время до станции */
  time: number | null;
  /** время до станции на транспорте */
  timeByCar: number | null;
  /** время до станции пешком */
  timeByWalk: number | null;
  /** вид транспорта для показа времени до метро */
  transportId: number | null;
}

export type TOfferHighways = Array<IOfferHighway>;

export interface IOfferHighway {
  /** id шоссе */
  id: number | null;
  /** название шоссе */
  name: string | null;
  /** расстояние до шоссе */
  distance: number | null;
  /** шоссе по умолчанию */
  isDefault: boolean;
  /** уникальный идентификатор */
  uuid: string;
}

export interface IGeoAddressItem {
  /** ID геосущности */
  id: number;
  /** тип геосущности */
  type: EGeoDetailType;
}

export enum EGeoDetailType {
  Country = 'country',
  District = 'district',
  House = 'house',
  Location = 'location',
  Railway = 'railway',
  Road = 'road',
  Street = 'street',
  Underground = 'underground',
}
